import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home/home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Home
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js